<template>
    <div class="">
        <h3>SENSE Troubleshooting</h3>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SenseTroubleshooting',
    methods: {
        ...mapActions({
            spinnerStop: 'spinner/stop'
        })
    },
    mounted () {
        this.spinnerStop()
    }
}
</script>

<style scoped lang="scss">
    h3 {
        color: #000;
        text-align: center;
        margin-top: 40px;
    }
</style>
